import '../../modules/mode-components';

import * as angular from 'angular';

import { modeEnterDirective } from './mode-enter-directive';

angular.module('mode.components').directive('modeEnter', modeEnterDirective);
